export default __webpack_public_path__ + "static/media/latex.3b40f2db.zip";